import _asyncToGenerator from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/regenerator";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { dispose } from '@tensorflow/tfjs-core';
/**
 * Turn any Scalar values in a Logs object into actual number values.
 *
 * @param logs The `Logs` object to be resolved in place.
 */

export function resolveScalarsInLogs(_x) {
  return _resolveScalarsInLogs.apply(this, arguments);
}
/**
 * Dispose all Tensors in an UnresolvedLogs object.
 *
 * @param logs An `UnresolvedLogs` object potentially containing `tf.Tensor`s in
 *   places where the values can be `tf.Tensor` or `number`.
 */

function _resolveScalarsInLogs() {
  _resolveScalarsInLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logs) {
    var promises, keys, scalarsToDispose, key, value, valueScalar, values, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(logs == null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            promises = [];
            keys = [];
            scalarsToDispose = [];

            for (key in logs) {
              value = logs[key];

              if (typeof value !== 'number') {
                valueScalar = value;
                promises.push(valueScalar.data());
                keys.push(key);
                scalarsToDispose.push(valueScalar);
              }
            }

            if (!(promises.length > 0)) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return Promise.all(promises);

          case 9:
            values = _context.sent;

            for (i = 0; i < values.length; ++i) {
              logs[keys[i]] = values[i][0];
            } // Dispose the original scalar tensors.


            dispose(scalarsToDispose);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveScalarsInLogs.apply(this, arguments);
}

export function disposeTensorsInLogs(logs) {
  if (logs == null) {
    return;
  }

  for (var key in logs) {
    var value = logs[key];

    if (typeof value !== 'number') {
      value.dispose();
    }
  }
}